import { defineMessages } from 'react-intl';
import { AutomaticSendType, InvitationType } from '@algoan/dashboard/model';

export const invitationMessages = defineMessages({
  title: {
    id: 'invitation.title',
    defaultMessage: 'Invitation',
    description: 'invitation title',
  },
  inviteButton: {
    id: 'invitation.invite_button',
    defaultMessage: 'Invite',
    description: 'invite button label',
  },
  customerInformationTitle: {
    id: 'invitation.customer_information.title',
    defaultMessage: 'Customer information',
    description: 'subtitle for the customer information section',
  },
  folderNumberInput: {
    id: 'invitation.customer_information.folder_number_input',
    defaultMessage: 'Folder number',
    description: 'folder number input label',
  },
  firstNameInput: {
    id: 'invitation.customer_information.first_name_input',
    defaultMessage: 'First name',
    description: 'first name input label',
  },
  lastNameInput: {
    id: 'invitation.customer_information.last_name_input',
    defaultMessage: 'Last name',
    description: 'last name input label',
  },
  emailAddressInput: {
    id: 'invitation.customer_information.email_address_input',
    defaultMessage: 'Email address',
    description: 'email address input label',
  },
  mobileNumberInput: {
    id: 'invitation.customer_information.mobile_number_input',
    defaultMessage: 'Mobile number',
    description: 'mobile number input label',
  },
  coBorrowerSectionTitle: {
    id: 'invitation.customer_information.co_borrower_title',
    defaultMessage: 'Co-borrower',
    description: 'Co-borrower title',
  },
  addCoBorrowerCheckbox: {
    id: 'invitation.customer_information.add_co_borrower_checkbox',
    defaultMessage: 'Add a co-borrower',
    description: 'checkbox label for adding a co-borrower',
  },
  firstNameInputOfCoBorrower: {
    id: 'invitation.customer_information.first_name_input_of_co_borrower',
    defaultMessage: 'First name of co-borrower',
    description: 'first name input label of co-borrower',
  },
  lastNameInputOfCoBorrower: {
    id: 'invitation.customer_information.last_name_input_of_co_borrower',
    defaultMessage: 'Last name of co-borrower',
    description: 'last name input label of co-borrower',
  },
  emailAddressInputOfCoborrower: {
    id: 'invitation.customer_information.email_address_of_co_borrower',
    defaultMessage: 'Email address of co-borrower',
    description: 'email address of co-borrower input label',
  },
  mobileNumberInputOfCoBorrower: {
    id: 'invitation.customer_information.mobile_number_input_of_co_borrower',
    defaultMessage: 'Mobile number of co-borrower',
    description: 'mobile number of co-borrower input label',
  },
  createFolderButton: {
    id: 'invitation.customer_information.create_folder_button',
    defaultMessage: 'create the folder',
    description: 'create folder button label',
  },
  notificationSuccess: {
    id: 'invitation.customer_information.notification_success',
    defaultMessage: 'Folder n°{folderNumber} has been successfully created.',
    description: 'notification success message',
  },
  notificationError: {
    id: 'invitation.customer_information.notification_error',
    defaultMessage: 'An error occured while creating the folder.',
    description: 'notification error message',
  },
  invitationLinkTitle: {
    id: 'invitation.invitation_link.title',
    defaultMessage: 'Invitation link',
    description: 'invitation link title',
  },
  manualSending: {
    id: 'invitation.invitation_link.manual_sending',
    defaultMessage: 'Manual sending',
    description: 'manual sending subtitle',
  },
  manualSendingDescription: {
    id: 'invitation.invitation_link.manual_sending_description',
    defaultMessage: 'Manual sending allows you to send an automatically generated invitation link yourself.',
    description: 'manual sending description',
  },
  manualSendingWarning: {
    id: 'invitation.invitation_link.manual_sending_description_warning',
    defaultMessage: 'Please note! This link is nominative and is only valid only once.',
    description: 'manual sending description warning',
  },
  createLinkButton: {
    id: 'invitation.invitation_link.create_link_button',
    defaultMessage: 'Copy a link',
    description: 'copy link button label',
  },
  or: {
    id: 'invitation.invitation_link.or',
    defaultMessage: 'Or',
    description: 'or to separete  manual sending and automatic sending',
  },
  automaticSending: {
    id: 'invitation.invitation_link.automatic_sending',
    defaultMessage: 'Automatic sending',
    description: 'automatic sending subtitle',
  },
  automaticSendingDescription: {
    id: 'invitation.invitation_link.automatic_sending_description',
    defaultMessage:
      'Automatic sending allows you to send a customized invitation to your entire organization.\u000aThis invitation has been set up by your organization.',
    description: 'manual sending description',
  },
  smsCheckbox: {
    id: 'invitation.invitation_link.sms_checkbox',
    defaultMessage: 'Sms',
    description: 'sms checkbox',
  },
  emailCheckbox: {
    id: 'invitation.invitation_link.email_checkbox',
    defaultMessage: 'Email',
    description: 'email checkbox',
  },
  sendInvitationButton: {
    id: 'invitation.invitation_link.send_invitation_button',
    defaultMessage: 'Send invitation',
    description: 'send invitation button label',
  },
  linkNotificationSuccess: {
    id: 'invitation.invitation_link.link_notification_success',
    defaultMessage: 'The invitation link has been successfully copied to your clipboard.',
    description: 'notification success message for the link',
  },
  linkNotificationError: {
    id: 'invitation.invitation_link.link_notification_error',
    defaultMessage: 'An error occurred while creating the invitation link.',
    description: 'notification error message for the link',
  },
  automaticSendingNotificationSuccess: {
    id: 'invitation.invitation_link.automatic_sending_notification_success',
    defaultMessage: 'The invitation was successfully sent automatically.',
    description: 'notification success message for the automatic sending',
  },
  automaticSendingNotificationError: {
    id: 'invitation.invitation_link.automatic_sending_notification_error',
    defaultMessage: 'An error occurred when the invitation was sent automatically.',
    description: 'notification error message for the automatic sending',
  },
  delete: {
    id: 'invitation.delete',
    defaultMessage: 'Delete',
    description: 'Title of delete button',
  },
  modify: {
    id: 'invitation.modify',
    defaultMessage: 'Modify',
    description: 'Title of modify button',
  },
  save: {
    id: 'invitation.save',
    defaultMessage: 'Save',
    description: 'Title of save button',
  },
  date: {
    id: 'invitation.invitation_history.date',
    defaultMessage: 'On {date}',
    description: 'history date',
  },
  [InvitationType.INVITATION_LINK_RETRIEVED]: {
    id: 'invitation.invitation_history.aggregation_created',
    defaultMessage: 'Invitation link created{senderUsername, select, undefined {} other { by {senderUsername}}}.',
    description: 'message for the aggregation created',
  },
  [AutomaticSendType.SMS]: {
    id: 'invitation.invitation_history.sms_sent',
    defaultMessage: 'Sms sent{senderUsername, select, undefined {} other { by {senderUsername}}}.',
    description: 'message for the sms sent',
  },
  [AutomaticSendType.EMAIL]: {
    id: 'invitation.invitation_history.email_sent',
    defaultMessage: 'Email sent{senderUsername, select, undefined {} other { by {senderUsername}}}.',
    description: 'message for the email sent',
  },
  historyTitle: {
    id: 'invitation.invitation_history.title',
    defaultMessage: 'History',
    description: 'invitation history title',
  },
  deleteFolderModalMessage: {
    id: 'invitation.delete_modal.delete_folder_modal_message',
    defaultMessage:
      'Are you sure you want to delete the folder\u000a n°{folderNumber} ?\u000a\u000aThis action is permanent and irreversible',
    description: 'Message in the delete folder modal',
  },
  submitModalButton: {
    id: 'invitation.delete_modal.submit',
    defaultMessage: 'Submit',
    description: 'Submit button',
  },
  cancelModalButton: {
    id: 'invitation.delete_modal.cancel',
    defaultMessage: 'Cancel',
    description: 'Cancel button',
  },
  deletionNotificationSuccess: {
    id: 'invitation.deletion_success',
    defaultMessage: 'The folder n°{folderNumber} has been successfully deleted.',
    description: 'Message on folder deletion success',
  },
  deletionNotificationFailure: {
    id: 'invitation.deletion_failure',
    defaultMessage: 'The folder n°{folderNumber} could not be deleted.',
    description: 'Message on folder deletion failure',
  },
  emailMessageTitle: {
    id: 'invitation.email_message',
    defaultMessage: 'Email message',
    description: 'email message tab title',
  },
  smsMessageTitle: {
    id: 'invitation.sms_message',
    defaultMessage: 'SMS message',
    description: 'sms message tab title',
  },
  emailTemplate: {
    id: 'invitation.email_template',
    defaultMessage:
      "Hello {recipientName},\u000a\u000a{customerName} invites you to connect your bank accounts to finalize your request.\u000aThis secure connection allows you to share the necessary financial information for the review of your file in just a few seconds.\u000a\u000a💡 The connection is made directly via your bank's interface.\u000a\u000a🔐 We do not have access to your banking credentials, and no transactions can be made on your accounts.\u000a\u000a🗑️ Your data is not retained.\u000a\u000a\u000a Click below to learn more and connect your bank: https://l.algoan.com/xxxx",
    description: 'email message tab content',
  },
  smsTemplate: {
    id: 'invitation.sms_template',
    defaultMessage: 'Hello {recipientName}, please connect your accounts here : https://l.algoan.com/xxxx',
    description: 'sms message tab content',
  },
  folderExistsError: {
    id: 'invitation.folder_exists_error',
    defaultMessage: 'This folder already exists.',
    description: 'Error message when the folder already exists',
  },
  modificationNotificationSuccess: {
    id: 'invitation.customer_modification.notification_success',
    defaultMessage: 'The folder n°{folderNumber} has been edited successfully.',
    description: 'Notification message when the folder has been edited successfully',
  },
  modificationNotificationError: {
    id: 'invitation.customer_modification.notification_error',
    defaultMessage: 'The folder n°{folderNumber} has been edited successfully.',
    description: 'Notification message when the folder has been edited successfully',
  },
  phoneNumberError: {
    id: 'invitation.phone_number_error',
    defaultMessage: 'The mobile number is invalid.',
    description: 'Error message when the phone number is invalid',
  },
  warningMessageForCustomIdentifier: {
    id: 'invitation.customer_information.warning_message_for_custom_identifier',
    defaultMessage:
      '💡Attention, please make sure that the file number is correct before creating the customer. This file cannot be changed afterwards.',
    description: 'warning message for the folder number',
  },
});
